import { render } from "./signCheck.vue?vue&type=template&id=6144771a&scoped=true&ts=true"
import script from "./signCheck.vue?vue&type=script&lang=ts"
export * from "./signCheck.vue?vue&type=script&lang=ts"

import "./signCheck.vue?vue&type=style&index=0&id=6144771a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6144771a"]])

export default __exports__